module.exports = __webpack_public_path__ + "img/stretch--genre1-thum2.7333f9b3.jpg";